module.exports = __webpack_public_path__ + "static/media/paperPlane.4f49a408.png";